import React, { useMemo } from "react";
import { useStores } from "_common/hooks";
import { useParams } from "react-router-dom";
import i18next from "i18next";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import DetailBlock from "./DetailBlock";

export default function NewsDetail4() {
  const params = useParams();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="container introduce-page !mt-[70px]">
      <HeaderTop title="Explained: What Is Proof of Work (PoW) in Blockchain?" />
      <div className="p-4 flex flex-col gap-4 bg-black">
        <img
          className="w-[98px]"
          src="https://api.demo92.apptestlive.com/assets/images/about.svg"
          alt="Logo"
        />
        <DetailBlock />
      </div>
    </div>
  );
}
